import React from 'react';
import Immutable from 'immutable';

import { Taxonomy } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { TaxonomyThemes } from '../../../types/uncinc_profile/taxonomy';

import './style.scss';

interface ViewThemesRelatedProps {
  entities: Immutable.List<ImmutableEntity<TaxonomyThemes>>;
}

const ViewThemesRelated: React.FC<ViewThemesRelatedProps> = ({
  entities,
}) => (
  <div className="ViewThemesRelated">
    <div className="row">
      {entities.map((entity) => {
        const theme = entity.toJS();
        const uuid = theme.uuid[0].value;
        const langcode = theme.langcode[0].value;
        const key = `${uuid}:${langcode}`;

        return (
          <div className="col-12 col-lg-4" key={key}>
            <Taxonomy
              entity={entity}
              viewMode="teaser"
            />
          </div>
        );
      })}
    </div>
  </div>
);

export default ViewThemesRelated;
